import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenGameClubQuery } from '@fgb/core';

@Component({
  selector: 'fgb-ten-game-club-score',
  templateUrl: './ten-game-club-score.component.html',
  styleUrls: ['./ten-game-club-score.component.scss'],
})
export class TenGameClubScoreComponent implements OnInit {
  @Input() total: number;
  score$: Observable<number>;

  constructor(private tenGameClubQuery: TenGameClubQuery) {}

  ngOnInit() {
    this.score$ = this.tenGameClubQuery.selectAllTenGameClubs().pipe(
      map((x) => {
        return x.filter((y) => y.GameAttended === true).length;
      })
    );
  }
}
